import React, { useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { FaTrashRestore } from "react-icons/fa";
import restoreCategory from "../../../api/restoreCategory";
import { AuthContext } from "../../../context/Auth/AuthContext";
import ButtonUI from "../../material-ui/ButtonUI";
import restore from "../../../images/recover-recycle-bin.svg";
const RestoreCategory = ({ id, setCategoryRestoredToTrue }) => {
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onRestoreCategory = async () => {
    const restoreCategoryFormResponse = await restoreCategory({
      token: token,
      id: id,
    });

    if (restoreCategoryFormResponse.code === 200) {
      setOpen(false);
      setCategoryRestoredToTrue();
      toast.success("Category is restored successfully", {
        position: "top-center",
        autoClose: 3000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div className="dialog-modal">
      <ButtonUI
        formButton={false}
        variant="outlined"
        buttonText={<FaTrashRestore />}
        style={{
          backgroundColor: "#28a745",
          color: "white",
          marginRight: "5px",
          padding: "7px",
        }}
        onClickFunc={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <FaTrashRestore />
          </div>
          <div className="popup-header-title">Restore Category</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to permanently restore this category ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#007bff",
              border: "1px solid #007bff",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "#007bff",
              border: "1px solid #007bff",
            }}
            autoFocus={true}
            onClickFunc={onRestoreCategory}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RestoreCategory;
